import React from 'react';
import styled from 'react-emotion';
import theme from '@jetshop/ui/utils/theme';

import Image from '@jetshop/ui/Image';
import { MainSectionWrapper } from './StartPage';
import { TrendLink } from '../ui/Button';

const Container = styled('div')`
  margin-bottom: 24px;
`;
const DescriptionBlock = styled('div')`
  line-height: 1.25;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  padding: 24px;

  ${theme('above.sm')} {
    max-width: 60vw;
    padding: 32px;
  }
  ${theme('above.md')} {
    max-width: 50vw;
    padding: 48px;
  }
`;

const Row = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
  position: relative;
  margin-bottom: 1rem;
  ${theme('below.sm')} {
    flex-direction: column;
  }
`;

const NewProductImage = styled('div')`
  width: 50%;
  ${theme('below.sm')} {
    width: 100%;
  }
`;
const NewProductText = styled(DescriptionBlock)`
  width: 50%;
  ${theme('below.sm')} {
    width: 100%;
  }
`;
const News = styled('h3')`
  font-size: 60px;
  text-align: center;
  margin-bottom: 32px;
  ${theme('below.sm')} {
    margin-bottom: 24px;
  }
`;
const SubtitleText = styled('p')`
  color: black;
  max-width: 420px;
  font-size: 30px;
  text-align: center;
  margin-bottom: 32px;
  ${theme('below.sm')} {
    font-size: 22px;
    margin-bottom: 24px;
  }
`;

const AmbassadorImage = styled('div')`
  width: 50%;

  ${theme('below.sm')} {
    width: 100%;
  }
`;
const AmbassadorText = styled(DescriptionBlock)`
  background-color: #000000;
  width: 50%;
  color: white;
  ${theme('below.sm')} {
    width: 100%;
  }
`;
const Ambassadors = styled('h3')`
  margin-bottom: 32px;
  color: #ffffff;
  font-size: 40px;
  ${theme('below.sm')} {
    margin-bottom: 24px;
  }
`;
const LearnMore = styled('p')`
  color: white;
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 32px;
  text-align: center;
  width: 360px;

  ${theme('below.sm')} {
    font-size: 18px;
    margin-bottom: 24px;
    width: auto;
  }
`;
const GetInspiredButton = styled(TrendLink)`
  margin: 4px;
  width: 100%;
  max-width: 300px;
`;

const FirstImage = ({ src }) => (
  <NewProductImage>
    <Image src={src} aspect="4:5" cover sizes={[1, 1 / 2]} />
  </NewProductImage>
);
const FirstSquare = ({ mainText, subtitleText, buttonText, buttonUrl }) => (
  <NewProductText>
    <News>{mainText}</News>
    <SubtitleText>{subtitleText}</SubtitleText>
    <GetInspiredButton to={buttonUrl}>{buttonText}</GetInspiredButton>
  </NewProductText>
);

const SecondImage = ({ src }) => (
  <AmbassadorImage>
    <Image src={src} aspect="5:4" cover sizes={[1, 1 / 2]} />
  </AmbassadorImage>
);

const SecondSquare = ({ mainText, subtitleText, buttonText, buttonUrl }) => (
  <AmbassadorText>
    <Ambassadors>{mainText}</Ambassadors>
    <LearnMore>{subtitleText}</LearnMore>
    <GetInspiredButton to={buttonUrl}>{buttonText}</GetInspiredButton>
  </AmbassadorText>
);

const Campaign = ({ firstImage, firstSquare, secondImage, secondSquare }) => {
  return (
    <MainSectionWrapper>
      <Container>
        <Row>
          <FirstImage {...firstImage} />
          <FirstSquare {...firstSquare} />
        </Row>
        <Row>
          <SecondSquare {...secondSquare} />
          <SecondImage {...secondImage} />
        </Row>
      </Container>
    </MainSectionWrapper>
  );
};

export default Campaign;
